import { request } from '../lib/http'

export function setEngineGeocode (data) {
  return request({
    url: `engine-geocode`,
    method: 'post',
    data
  })
}
